import api from "../api";
import { auth, property } from "../api_endpoints";


export const LoginUser=async(data)=>{
  try {
    const res= await api.post(auth.login, data,{
      headers: {
        'Content-Type': 'application/json',
      },
    } );
    return res
    
  } catch (error) {
    return error
  }
}

export const RegisterUser=async(data)=>{
  try {
    const res= await api.post(auth.register, data,{
      headers: {
        'Content-Type': 'application/json',
      },
    } );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const ProfileUser=async(token)=>{
  try {
    const res= await api.get(auth.getProfile,{
      headers: {
        'Authorization':`Bearer ${token}`,
       
      },
    } );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const Paymenthistory=async(token)=>{
  try {
    const res= await api.get(auth.paymentHistory,{
      headers: {
        'Authorization':`Bearer ${token}`,
       
      },
    } );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}


export const logoutUser=async(token)=>{
  try {
    const res= await api.post(auth.logoutUser,{
      headers: {
        'Authorization':`Bearer ${token}`,
       
      },
    } );


    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const getPackages=async()=>{
      try {
            const res= await api.get(property.getPackages,{
      headers: {
       
       'Content-Type': 'application/json',
      },
    } );
    console.log(res);
    
    return res
      } catch (error) {
        console.log(error);
        return error
        
      }
}

export const getGalleries=async()=>{
      try {
            const res= await api.get(property.getGallery,{
      headers: {
       
       'Content-Type': 'application/json',
      },
    } );
    console.log(res);
    
    return res
      } catch (error) {
        console.log(error);
        return error
        
      }
}


export const createOrderPackage=async(data,token)=>{
  try {
    console.log(data);
    
    const res= await api.post(property.orderPackage, data ,
      {
      headers: {
       'content-type': 'application/json',
        'Authorization':`Bearer ${token}`,
      },
    }
    );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}

export const VerifyPayment=async(data,token)=>{
  try {
    const res= await api.post(property.verifyPayment, data ,
      {
      headers: {
       'content-type': 'application/json',
        'Authorization':`Bearer ${token}`,
      },
    }
    );
    console.log(res);
    
    return res
    
  } catch (error) {
    return error
  }
}